// extracted by mini-css-extract-plugin
export default {"audio-render":"AudioRender_audio-render__g8hZC","audio-player":"AudioRender_audio-player__zV0fs"};